import { createUseStyles } from 'react-jss';

const styles = {
  effectiveDateWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  statuses: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.3rem',
  },
  effectiveDateStatusesWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    minHeight: '2.2rem',
  },
  statusTooltipWrapper: {
    height: '2.2rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
